import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { allowedModules } from '../utils/navigation';
import { recordAuditActivity, auditModuleForPath } from '../services/auditService';

// Record only recognized, authorized module opens. Public form URLs and query
// strings can contain student/session tokens and must never enter this stream.
export default function AuditActivityTracker() {
  const { user, role, permissions, loading, error, erpInactive, isReview } = useAuth();
  const { pathname } = useLocation();
  const previous = useRef(null);
  useEffect(() => {
    if (!user?.uid || loading || error || erpInactive || isReview) { previous.current = null; return; }
    const route = allowedModules(role, permissions).find(item => auditModuleForPath(item.path) && (pathname === item.path || (item.path !== '/' && pathname.startsWith(`${item.path}/`))));
    if (!route) { previous.current = null; return; }
    const key = `${user.uid}:${route.path}`;
    if (previous.current === key) return;
    previous.current = key;
    recordAuditActivity('module_open', auditModuleForPath(route.path)).catch(() => {
      // An unavailable activity endpoint must not block staff from their work.
    });
  }, [user?.uid, role, permissions, loading, error, erpInactive, isReview, pathname]);
  return null;
}
